module.exports = __webpack_public_path__ + "img/feedback-loop.66a3445e.webp";